// extracted by mini-css-extract-plugin
export default {"LoadError":"bet_a bhf_qq bhf_a bhf_w bhf_j bhf_q","LoadError__icon":"bet_b bhf_vj bhf_fk bhf_su","LoadError__message":"bet_c bhf_fk bhf_tp"};